import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

import Scrollspy from 'react-scrollspy';

const HumanPractices = () => {
  useEffect(() => {
    
  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Integrated Human Practices</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Integrated Human Practices
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Integrated', 'Public', 'ExpertInterviews','URBAN']}
              currentClassName="active">
              <li><a href="#Integrated">Integrated Human Practices</a></li>
              <li><a href="#Proper">Public opinion survey &amp; its analysis</a></li>
              <li><a href="#ExpertInterviews">Expert Interview</a></li>
              <li><a href="#URBAN"> URBAN MUSHROOM VISIT</a></li>
            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style">
          <section id="Integrated">
            
          <h1>
              Integrated Human Practices
          </h1>

            <p>Our main project goal is to develop a fungal system to synthesise novel therapeutics which are effective against cancer cells. Our targets were to bypass the obstacles of cost affordability and, since toxic reagents are used in common types of anticancer drugs, to bypass environmental concerns as well. However, we want to see if our project is ultimately <strong>good for the world, </strong>and how it may <strong>impact the global community </strong>and <strong>certain communities in Hong Kong. </strong>through our human practices activities, we can understand more about those, and we can improve our project holistically to better address the real issues that society faces. that there are other factors in cancer therapy aside from drug effectiveness.&nbsp;</p>

            <p>Through our <a href="https://2022.igem.wiki/cityu-hongkong/public-survey"><strong>public opinion survey</strong></a> and <a href="https://youtu.be/MqBTq9mgEU0"><strong>interviews with experts</strong></a> in the field of oncology, microbiology, and medicine, we realized that <strong>we must consider public acceptance and safety.</strong></p>
            <p>To enhance public acceptance, weWe used our <a href="https://2022.igem.wiki/cityu-hongkong/SocialMedia">social media</a> platforms to raise awareness of the benefits of our project and natural products, as well as a <a href="https://2022.igem.wiki/cityu-hongkong/SynBio">synthetic biology workshop</a> with over 110 secondary school kids from around the world.&nbsp;</p>
            <p>In terms of safety of the drug, we incorporated new <em>in vitro</em> testing techniques and discovered the anticancer mechanisms of our novel synthesized compounds through <em>in silico modeling</em> as suggested by the interviewed experts.&nbsp;</p>
          </section>

          <br />
          <br />


          <section id="Public">
          <h1>
              Public opinion survey &amp; its analysis
          </h1>

            <p>Despite the progressive advancement in the medical science field, society is still facing numerous global health challenges, including cancer, a debilitating disease which has affected the lives of many. <strong>Hence, there is an unmet and clinical need for new and effective cancer drugs. </strong>Yet, there have been a number of long-existing problems in drug discovery which continues to hinder the development of cost-effective, accessible, and efficacious cancer drugs. To address this, the CityU iGEM Team 2022: &lsquo;SeCure&rsquo;, aims to develop a simple and cost-effective fungal synthetic biology platform using a fungus, <em>Aspergillus oryzae</em>, to produce various novel derivatives of secalonic acid, a fungal natural product with known anticancer properties</p>
            <p>In view of that, we have gathered data on the public awareness of cancer, synthetic biology, natural products as a source of pharmaceutical drugs, and the public perceived preference of cancer drugs. We also investigated public opinions on our project to discover how it may affect the general public and how we can raise the general awareness regarding these aforementioned topics. Consequently, we designed a public survey, and the results will be analyzed in this paper.</p>
           
            <br />
            <p><strong>Please follow this link to see the Analysis on Public opinion survey:</strong></p>
            <p><a href="https://2022.igem.wiki/cityu-hongkong/public-survey"><strong>https://2022.igem.wiki/cityu-hongkong/public-survey</strong></a></p>

          </section>
          <br />
          <br />




          <section id="ExpertInterviews">

            <h1>
              Expert Interview

            </h1>

            <p></p>
            
            <div style={{ display: 'flex' }}>
              <div style={{ width: '30%', paddingRight: 20, paddingTop: 30 }}>
                
                <img style={{ width: '100%',height:'auto',objectFit:'initial' }} src="https://i.postimg.cc/3x66mSjx/image.png" alt="" />
                <div>
                  <h3 style={{ margin: 0 }}>
                    Dr Jemma Arakelyan, MD
                  </h3>
                  <em>
                    Yerevan State Medical University (M.D.)
                    Harvard Medical School (HICR scholar)
                  </em>
                </div>
              </div>
              <div style={{ width: '70%' }}>
                <p>
                  Our team arranged an interview with an expert, Dr Jemma Arakelyan, an oncologist who has been practising for eight years, to learn more about the disease our project aims to tackle. The interview began with Dr Arakelyan expressing her passion for the field of oncology and what inspired her to divulge into what is often perceived as a tense field. She mentioned how the field bridges humanity and science and her interest in oncology research for cancer drug discovery…  <a href="https://2022.igem.wiki/cityu-hongkong/expert-interviews">read more</a>
                </p>
              </div>
            </div>
            <br />


            <iframe title="CityU_HongKong: Interview with the Oncologist Dr Jemma Arakelyan (2022) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/a899bf82-23cd-47e5-9b26-493fff778a96" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>
            <br />
            <p><strong>Please follow this link to learn more about the interview with Dr. Jemma Arakelyan, MD: </strong><br /><br /><a href="https://2022.igem.wiki/cityu-hongkong/expert-interviews"><strong>https://2022.igem.wiki/cityu-hongkong/expert-interviews</strong></a><strong></strong></p>

          </section>

          <br />
          <br />

          <section id="URBAN">
            <h1>
              URBAN MUSHROOM VISIT
            </h1>
            <iframe title="CityU_HongKong: A day at Urban Mushroom (2022) [English]" width="100%" height="415" src="https://video.igem.org/videos/embed/c84fc4ce-e214-491e-9859-5eccf52b43b9" frameborder="0" allowfullscreen="" sandbox="allow-same-origin allow-scripts allow-popups"></iframe>

            <p>Urban Mushroom is a farm in Hong Kong, founded and operated solely by Russell. He studied BSc in engineering at Chinese University of Hong Kong, an MSc in Sustainable Agriculture in the UK (NCL), and gained insights on developing sustainable agriculture in Hong Kong.&nbsp;</p>
            <p><strong>He cultivates mushrooms</strong> as he found that mushrooms need relatively less light to grow, which suits his home environment. <strong>He utilizes used coffee beans to grow mushrooms. </strong>Russell is currently cultivating four types of Oyster mushrooms (<em>Pink Oyster Mushroom, Golden Oyster Mushroom, Phoenix mushroom, and Common Oyster Mushroom</em>).</p>
            <p><strong><em>Aspergillus oryzae</em></strong><strong> is fungi common in East Asia, including Hong Kong</strong></p>
            <p>High public awareness of these fungi and their possible applications would benefit enterprises, ventures, and research involving these fungi in Hong Kong. <strong>Therefore, we present this video in Cantonese to reach the local Hong Kong community</strong>. We also included <strong>English subtitles</strong> to ensure that the global community can also enjoy the video.&nbsp;</p>
            <p><strong>We hope that this video would help to raise public awareness of fungi and how they may be used to advance drug development and promote sustainability.</strong></p>
            <p><strong>To read the interview, please follow the link to the </strong><a href="https://2022.igem.wiki/cityu-hongkong/urban-mushroom-visit"><strong>Urban Mushroom Visit&rsquo;s page</strong></a><strong>:</strong></p>
            <p><a href="https://2022.igem.wiki/cityu-hongkong/urban-mushroom-visit"><strong>https://2022.igem.wiki/cityu-hongkong/urban-mushroom-visit</strong></a></p>
          </section>
          <br />
          
        </div>
      </section>
    </div>
  );
}

export default HumanPractices;
